import React from 'react'
import cx from 'classnames'
import Icon from 'lib/components/icon'

let stepper = 0

function Slide({ title, text, image, isCurrent }) {
  let className = cx('welcome__slide', {
    '-active': isCurrent
  })

  return (
    <div className={className}>
      <div>
        <h3 dangerouslySetInnerHTML={{ __html: title }} />
        <p dangerouslySetInnerHTML={{ __html: text }} />
      </div>
      <div
        className="welcome__slide__image"
        dangerouslySetInnerHTML={{ __html: image }}
      />
    </div>
  )
}

function PageButton({ title, index, isCurrent, onClick }) {
  let className = cx('welcome__pagination__button', {
    '-active': isCurrent
  })

  return (
    <button key={index} className={className} onClick={() => onClick(index)}>
      <span className="screenreader-only">{title}</span>
    </button>
  )
}

class Welcome extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      index: 0, // current slide index
      total: props.slides ? props.slides.length : 0
    }
  }

  previous = () => {
    let previous = Math.max(0, this.state.index - 1)
    this.navigateTo(previous)
  }

  navigateTo = index => {
    this.setState({ index })
  }

  next = () => {
    let next = Math.min(this.state.total - 1, this.state.index + 1)
    this.navigateTo(next)
  }

  render() {
    let { slides = [] } = this.props

    let currentSlide = this.props.slides[this.state.index]
    currentSlide.image = currentSlide.image.replace(
      /gif(\?v=\d+)*/g,
      'gif?v=' + stepper++
    )

    return (
      <div className="welcome">
        <div className="welcome__slides">
          <Slide key={0} {...currentSlide} isCurrent={true} />
        </div>
        {this.state.total > 0 && (
          <div className="welcome__pagination">
            <button
              className="welcome__pagination__arrow"
              onClick={this.previous}
              disabled={this.state.index === 0}
            >
              <Icon type="arrow-left" width="36px" height="36px" />
              <span className="screenreader-only">Previous</span>
            </button>

            {slides.map((slide, i) => {
              return (
                <PageButton
                  key={i}
                  title={slide.title}
                  index={i}
                  isCurrent={i === this.state.index}
                  onClick={this.navigateTo}
                />
              )
            })}

            <button
              className="welcome__pagination__arrow"
              onClick={this.next}
              disabled={this.state.index === this.state.total - 1}
            >
              <Icon type="arrow-right" width="36px" height="36px" />
              <span className="screenreader-only">Next</span>
            </button>
          </div>
        )}
      </div>
    )
  }
}

export default Welcome



// WEBPACK FOOTER //
// ./src/components/welcome/welcome.js